'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { isEmpty } from 'underscore';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIDropdownFooter from 'UIComponents/dropdown/UIDropdownFooter';
import UIList from 'UIComponents/list/UIList';
import AllTabsMenuButton from 'DesignManagerIde/components/tabs/AllTabsMenuButton';
import UIButton from 'UIComponents/button/UIButton';

class AllTabsMenu extends Component {
  constructor(...args) {
    super(...args);

    this.closeAllTabs = () => {
      const unpinnedTabs = this.props.tabsOrder.filter(tabId => !this.props.tabsById[tabId].pinned);
      this.props.closeTabs(unpinnedTabs);
    };
  }

  renderOptions() {
    const {
      tabsById,
      tabsOrder,
      openTab
    } = this.props;
    return tabsOrder.map(tabId => {
      const tab = tabsById[tabId];
      return /*#__PURE__*/_jsx(AllTabsMenuButton, {
        tabId: tab.id,
        tab: tab,
        openTab: openTab
      }, tab.id);
    });
  }

  render() {
    const options = this.renderOptions();
    return /*#__PURE__*/_jsxs(UIDropdown, {
      buttonClassName: "all-tabs-button",
      buttonUse: "transparent",
      disabled: isEmpty(this.props.tabsOrder),
      iconName: null,
      menuWidth: 200,
      children: [/*#__PURE__*/_jsx("div", {
        className: "tab-dropdown-container",
        children: /*#__PURE__*/_jsx(UIList, {
          children: options
        })
      }), /*#__PURE__*/_jsx(UIDropdownFooter, {
        className: "p-y-0",
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "link-danger",
          className: "tab-menu-options",
          onClick: this.closeAllTabs,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "designManager.tabs.closeAllTabsLabel"
          })
        })
      })]
    });
  }

}

AllTabsMenu.propTypes = {
  tabsById: PropTypes.object.isRequired,
  tabsOrder: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])).isRequired,
  openTab: PropTypes.func.isRequired,
  closeTabs: PropTypes.func.isRequired
};
export default AllTabsMenu;